export enum MaintenanceRequestStatus {
  Complete = "complete",
  Cancelled = "cancelled",
  InProgress = "inprogress",
  New = "new"
}